import request from '../../request'
import {survey} from '../../endpoints'

export default class surveysApi {
  static async post(data) {
    return request({
      url: survey.surveys(),
      method: 'POST',
      data: data,
    })
  }

  static async delete(data) {
    return request({
      url: survey.delete(),
      method: 'POST',
      data: data,
    })
  }
  static async put(data) {
    return request({
      url: survey.surveys(),
      method: 'PUT',
      data: data,
    })
  }

  static async get(token) {
    return request({
      url: survey.get(),
      method: 'POST',
      data: token,
    })
  }
  static async getAll(cId, cType, limit, sites) {
    return request({
      url: survey.getAll(cId, cType, limit, sites),
      method: 'POST',
      data: JSON.stringify(sites),
    })
  }

  static async submit(obj, language) {
    return request({
      url: survey.submit(language),
      method: 'POST',
      data: JSON.stringify(obj),
    })
  }

  static async resendInvites(obj) {
    return request({
      url: survey.resendInvites(),
      method: 'POST',
      data: JSON.stringify(obj),
    })
  }

  static async updateParticipants(
    token,
    filters,
    parentCount,
    staffCount,
    studentCount,
    isWidgitEnabled
  ) {
    return request({
      url: survey.updateParticipants(),
      method: 'POST',
      data: JSON.stringify({
        token: token,
        participantFilter: JSON.stringify(filters),
        parentCount: parentCount,
        staffCount: staffCount,
        pupilCount: studentCount,
        isWidgitEnabled: isWidgitEnabled,
      }),
    })
  }

  static async getSurveyForResults(schoolId, matId) {
    return request({
      url: survey.getSurveyForResults(schoolId, matId),
      method: 'GET',
    })
  }
  static async UpdateSurveyAnnonymise(token) {
    return request({
      url: survey.UpdateSurveyAnnonymise(),
      method: 'POST',
      data: token,
    })
  }

  static async getParticipationBreakdown(id) {
    return request({
      url: survey.getParticipationBreakdown(id),
      method: 'GET',
    })
  }

  static async getParticipationBreakdownBySchool(groupId, schoolId, surveyId) {
    return request({
      url: survey.getParticipationBreakdownBySchool(
        groupId,
        schoolId,
        surveyId
      ),
      method: 'GET',
    })
  }

  static async getPupilSurveys(schoolId, studentId) {
    return request({
      url: survey.getPupilSurveys(schoolId, studentId),
      method: 'GET',
    })
  }

  static async getSchoolsofMatSurveys(id, sites) {
    // get schools surveys which are mat schools
    return request({
      url: survey.getSchoolsofMatSurveys(id),
      method: 'POST',
      data: JSON.stringify(sites),
    })
  }

  static async getMatSurveysForSchool(mid, sid) {
    return request({
      url: survey.getMatSurveysForSchool(mid, sid),
      method: 'GET',
    })
  }
  static async getSurveyStatus(id) {
    return request({
      url: survey.getSurveyStatus(id),
      method: 'GET',
    })
  }

  static async GetSurveyForReviewByToken(token) {
    return request({
      url: survey.GetSurveyForReviewByToken(),
      method: 'POST',
      data: token,
    })
  }
  static async UpdateAnonymousShareSettings(token, anonyous, share) {
    return request({
      url: survey.UpdateAnonymousShareSettings(anonyous, share),
      method: 'POST',
      data: token,
    })
  }

  static async getSurveyParticipationFilters(token) {
    return request({
      url: survey.getSurveyParticipationFilters(),
      method: 'POST',
      data: token,
    })
  }
  static async addUpdateParticipantFilter(data) {
    return request({
      url: survey.addUpdateParticipantFilter(),
      method: 'POST',
      data: data,
    })
  }

  static async updateLiveSurveyEndDate(payload) {
    return request({
      url: survey.UpdateLiveSurveyEndDate(),
      method: 'POST',
      data: JSON.stringify(payload),
    })
  }

  static async getUnassignedSchools(token) {
    return request({
      url: survey.getUnassignedSchools(token),
      method: 'GET',
    })
  }

  static async addSchoolsToLiveSurvey(payload) {
    return request({
      url: survey.addSchoolsToLiveSurvey(),
      method: 'POST',
      data: JSON.stringify(payload),
    })
  }
}
